import React, { useEffect, useRef, useState } from 'react';
import '../CSS/Global.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Sidebar from './SideBar';
import { useSidebar } from '../SidebarContext';
import Header from './Header';

function convertToWords(num) {
    num = Number(num);
    if (isNaN(num) || num <= 0) return '';
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
        'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
        'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
        'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numberToWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + numberToWords(n % 100) : "");
        if (n < 100000) return numberToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + numberToWords(n % 1000) : "");
        if (n < 10000000) return numberToWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + numberToWords(n % 100000) : "");
        return numberToWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + numberToWords(n % 10000000) : "");
    };

    return numberToWords(Number(num));
}


const ResidentRentEdit = () => {
    const { isSidebarOpen } = useSidebar();
    const [amenities, setAmenities] = useState([]);
    const [category, setCategory] = useState([]);
    const [selectedAmenities, setSelectedAmenities] = useState([]);
    const [locationAdvantages, setLocationAdvantages] = useState([]);
    const [selectedLocationAdvantages, setSelectedLocationAdvantages] = useState([]);
    const [availabilityStatus, setAvailabilityStatus] = useState("");
    const fileInputRef = useRef(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [dragging, setDragging] = useState(false);
    const [errors, setErrors] = useState({});
    const [load, setLoad] = useState(true);
    const [watersupply, setWaterSupply] = useState([]);
    const [selectedWaterSupply, setSelectedWaterSupply] = useState([]);
    const [security, setSecurity] = useState([]);
    const [selectedsecurity, setSelectedSecurity] = useState([]);

    const [data, setData] = useState({
        building_name: "",
        address: "",
        city: "",
        floorPlan: "",
        flatType: [],
        carpetArea: [{ carpetArea: "", price: "" }],
        buildupArea: "",
        totalFloors: "",
        floorLevel: "",
        bedrooms: "",
        jodi1: "",
        jodi2: "",
        bathrooms: "",
        balconies: "",
        availability: "",
        ageOfBuilding: "",
        possesionTill: "",
        ownership: "",
        facing: "",
        maintenance: "",
        parking: "",
        booking_amount: "",
        virtual_tour: "",
        furnishStatus: "",
        category: "",
        dev_logo: "",
        developer_name: '',
        developer_description: '',
        property_description: '',

        rkCarpetAreas: [{ value: "", showMinus: false }],
        rkBuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        rkSuperBuiltUpAreas: [{ value: "", showMinus: false }],
        rkExpectedPrices: [{ value: '' }],
        rkBalconies: '',
        rkBathrooms: '',
        rkFurnishStatus: '',
        rkConditionOfFlat: '',
        rkMonthlyMaintenance: '',
        rkPriceAllInclusive: '',
        rkPriceNegotiable: '',
        rkPreferredCashType: [],
        rkLoanFacility: '',
        rkDocumentsAvailable: '',
        rkFloorPlan: '',

        // 1BHK-specific fields
        bhk1CarpetAreas: [{ value: "", showMinus: false }],
        bhk1BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        bhk1SuperBuiltUpAreas: [{ value: "", showMinus: false }],
        bhk1ExpectedPrices: [{ value: '' }],
        bhk1Bedrooms: '',
        bhk1BedroomsJodi1: '',
        bhk1BedroomsJodi2: '',
        bhk1Balconies: '',
        bhk1Bathrooms: '',
        bhk1FurnishStatus: '',
        bhk1ConditionOfFlat: '',
        bhk1MonthlyMaintenance: '',
        bhk1PriceAllInclusive: '',
        bhk1PriceNegotiable: '',
        bhk1PreferredCashType: [],
        bhk1LoanFacility: '',
        bhk1DocumentsAvailable: '',
        bhk1FloorPlan: '',

        bhk2CarpetAreas: [{ value: "", showMinus: false }],
        bhk2BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        bhk2SuperBuiltUpAreas: [{ value: "", showMinus: false }],
        bhk2ExpectedPrices: [{ value: '' }],
        bhk2Bedrooms: '',
        bhk2BedroomsJodi1: '',
        bhk2BedroomsJodi2: '',
        bhk2Balconies: '',
        bhk2Bathrooms: '',
        bhk2FurnishStatus: '',
        bhk2ConditionOfFlat: '',
        bhk2MonthlyMaintenance: '',
        bhk2PriceAllInclusive: '',
        bhk2PriceNegotiable: '',
        bhk2PreferredCashType: [],
        bhk2LoanFacility: '',
        bhk2DocumentsAvailable: '',
        bhk2FloorPlan: '',

        bhk3CarpetAreas: [{ value: "", showMinus: false }],
        bhk3BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        bhk3SuperBuiltUpAreas: [{ value: "", showMinus: false }],
        bhk3ExpectedPrices: [{ value: '' }],
        bhk3Bedrooms: '',
        bhk3BedroomsJodi1: '',
        bhk3BedroomsJodi2: '',
        bhk3Balconies: '',
        bhk3Bathrooms: '',
        bhk3FurnishStatus: '',
        bhk3ConditionOfFlat: '',
        bhk3MonthlyMaintenance: '',
        bhk3PriceAllInclusive: '',
        bhk3PriceNegotiable: '',
        bhk3PreferredCashType: [],
        bhk3LoanFacility: '',
        bhk3DocumentsAvailable: '',
        bhk3FloorPlan: '',

        bhk4CarpetAreas: [{ value: "", showMinus: false }],
        bhk4BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        bhk4SuperBuiltUpAreas: [{ value: "", showMinus: false }],
        bhk4ExpectedPrices: [{ value: '' }],
        bhk4Bedrooms: '',
        bhk4BedroomsJodi1: '',
        bhk4BedroomsJodi2: '',
        bhk4Balconies: '',
        bhk4Bathrooms: '',
        bhk4FurnishStatus: '',
        bhk4ConditionOfFlat: '',
        bhk4MonthlyMaintenance: '',
        bhk4PriceAllInclusive: '',
        bhk4PriceNegotiable: '',
        bhk4PreferredCashType: [],
        bhk4LoanFacility: '',
        bhk4DocumentsAvailable: '',
        bhk4FloorPlan: '',
        extra1: "",
        extra2: ""
    })
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";

    const navigate = useNavigate();

    const { id } = useParams();

    const handleAmenityChange = (event) => {
        const { value } = event.target;
        if (selectedAmenities.includes(value)) {
            setSelectedAmenities(selectedAmenities.filter((item) => item !== value));
        } else {
            setSelectedAmenities([...selectedAmenities, value]);
        }
    };

    const handleLocationAdvantageChange = (event) => {
        const { value } = event.target;
        if (selectedLocationAdvantages.includes(value)) {
            setSelectedLocationAdvantages(
                selectedLocationAdvantages.filter((item) => item !== value)
            );
        } else {
            setSelectedLocationAdvantages([...selectedLocationAdvantages, value]);
        }
    };



    const [showCarpet, setShowCarpet] = useState(false);
    const [showSuperBuiltUp, setShowSuperBuiltUp] = useState(false);
    const [viewBedroomsMore, setViewBedroomsMore] = useState(false);
    const [viewBalconiesMore, setViewBalconiesMore] = useState(false);
    const [viewBathroomsMore, setViewBathroomsMore] = useState(false);
    const [openIndex, setOpenIndex] = useState(null);
    const [superBuiltUpAreas, setSuperBuiltUpAreas] = useState([{ value: "", showMinus: false }]);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };


    // const handleDeleteImage = async (imageName) => {
    //     // ✅ Step 1: Remove image from the UI immediately
    //     // const updatedImages = data.formImages.filter(img => img !== imageName);
    //     // setData((prevData) => ({
    //     //     ...prevData,
    //     //     formImages: updatedImages
    //     // }));



    // };

    const handleDeleteImage = async (index) => {
        try {
            const response = await fetch(`https://100real.xyz/rentresident/updatedelete-property/${id}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ deletedImageIndex: index }), // ✅ Send index
            });

            const result = await response.json();
            if (response.ok) {

                // ✅ Remove image from frontend state
                // setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
                fetchData();
                // toast.success("Image deleted successfully!");
            } else {
                toast.error(result.message || "Error deleting image");
            }
        } catch (error) {
            console.error("Error deleting image:", error);
            toast.error("Error deleting image");
        }
    };

    const maxFiles = 20; // Max number of files
    const maxSize = 20 * 1024 * 1024; // 20MB size limit in bytes

    const handleBrowseClick = (event) => {
        event.preventDefault();
        fileInputRef.current.click(); // Trigger the hidden file input
    };

    const formatFileSize = (size) => {
        if (size < 1024) return `${size} B`;
        if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
        return `${(size / (1024 * 1024)).toFixed(2)} MB`;
    };

    const flatTypeFields = {
        "1RK": [
            "rkCarpetAreas", "rkBuiltUpAreas", "rkExpectedPrices", "rkBalconies", "rkBathrooms",
            "rkFurnishStatus", "rkConditionOfFlat", "rkMonthlyMaintenance", "rkPriceAllInclusive", "rkPriceNegotiable",
            "rkPreferredCashType",
        ],
        "1BHK": [
            "bhk1CarpetAreas", "bhk1ExpectedPrices", "bhk1Bedrooms", "bhk1Balconies", "bhk1Bathrooms",
            "bhk1FurnishStatus", "bhk1ConditionOfFlat", "bhk1MonthlyMaintenance", "bhk1PriceAllInclusive",
            "bhk1PriceNegotiable", "bhk1PreferredCashType",
        ],
        "2BHK": [
            "bhk2CarpetAreas", "bhk2ExpectedPrices", "bhk2Bedrooms", "bhk2Balconies", "bhk2Bathrooms",
            "bhk2FurnishStatus", "bhk2ConditionOfFlat", "bhk2MonthlyMaintenance", "bhk2PriceAllInclusive",
            "bhk2PriceNegotiable", "bhk2PreferredCashType",
        ],
        "3BHK": [
            "bhk3CarpetAreas", "bhk3ExpectedPrices", "bhk3Bedrooms", "bhk3Balconies", "bhk3Bathrooms",
            "bhk3FurnishStatus", "bhk3ConditionOfFlat", "bhk3MonthlyMaintenance", "bhk3PriceAllInclusive",
            "bhk3PriceNegotiable", "bhk3PreferredCashType",
        ],
        "4BHK": [
            "bhk4CarpetAreas", "bhk4ExpectedPrices", "bhk4Bedrooms", "bhk4Balconies", "bhk4Bathrooms",
            "bhk4FurnishStatus", "bhk4ConditionOfFlat", "bhk4MonthlyMaintenance", "bhk4PriceAllInclusive",
            "bhk4PriceNegotiable", "bhk4PreferredCashType",
        ]
    };


    const validateFields = () => {
        const newErrors = {};

        // Validate general required fields
        const generalRequiredFields = [
            "building_name",
            "address",
            "city",
            ...Object.keys(flatTypeFields)
                .filter((type) => data.flatType.includes(type)) // Validate only selected flat types
                .flatMap((type) => flatTypeFields[type]),
            "category",
        ];

        generalRequiredFields.forEach((field) => {
            const value = data[field];
            if (
                value === undefined ||
                value === null ||
                (typeof value === "string" && value.trim() === "") ||
                (Array.isArray(value) && value.length === 0)
            ) {
                newErrors[field] = "This field is required*";
            }
        });

        // Validate flatType-specific fields
        data.flatType.forEach((type) => {
            const fieldsForType = flatTypeFields[type] || [];
            fieldsForType.forEach((field) => {
                const value = data[field] ?? '';

                if (flatTypeFields[data.flatType]?.includes(field)) {
                    if (
                        value === undefined ||
                        value === null ||
                        (Array.isArray(value) && value.length === 0) ||
                        (typeof value === 'string' && value.trim() === '')
                    ) {
                        newErrors[field] = 'This field is required*';
                    }
                } else if (
                    value === undefined ||
                    value === null ||
                    (Array.isArray(value) && value.length === 0) ||
                    (typeof value === 'string' && value.trim() === '')
                ) {
                    newErrors[field] = 'This field is required*';
                }
            });
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };



    const addInput = () => {
        setData((prevData) => ({
            ...prevData,
            carpetArea: [...prevData.carpetArea, { carpetArea: "", price: "" }],
        }));
    };

    const deleteInput = (index) => {
        setData((prevData) => ({
            ...prevData,
            carpetArea: prevData.carpetArea.filter((_, i) => i !== index),
        }));
    };


    const handleDynamicChange = (e, fieldName, index, fieldKey = "value") => {
        const { value } = e.target;

        setData((prevState) => {
            const updatedField = Array.isArray(prevState[fieldName]) // Ensure it's an array
                ? [...prevState[fieldName]]
                : []; // If not, initialize it as an empty array

            // Update the specific field (value or expectedPrice)
            updatedField[index] = {
                ...updatedField[index],
                [fieldKey]: value,
            };

            return {
                ...prevState,
                [fieldName]: updatedField,
            };
        });
    };

    const handleAddField = (fieldName) => {
        setData((prevState) => ({
            ...prevState,
            [fieldName]: [
                ...prevState[fieldName],
                { value: "", expectedPrice: "", showMinus: false },
            ],
        }));
    };

    const handleRemoveField = (fieldName, index) => {
        setData((prevState) => {
            const updatedField = [...prevState[fieldName]];
            updatedField.splice(index, 1); // Remove the field at the given index
            return {
                ...prevState,
                [fieldName]: updatedField,
            };
        });
    };


    const handleEnterPress = (e, type) => {
        if (e.key === "Enter") {
            const value = e.target.value;
            if (Number(value) >= 5) {
                setData((prev) => ({
                    ...prev,
                    [type]: String(value),
                }));
            }
        }
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        const validFiles = files.filter(file =>
            file.size <= maxSize &&
            ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type)
        );

        const duplicateFiles = validFiles.filter(file =>
            uploadedFiles.some(existingFile => existingFile.name === file.name)
        );

        if (duplicateFiles.length > 0) {
            toast.error('You cannot upload duplicate images.');
            return;
        }

        if (uploadedFiles.length + validFiles.length > maxFiles) {
            toast.error(`You can upload a maximum of ${maxFiles} images.`);
            return;
        }

        setUploadedFiles(prevFiles => [...prevFiles, ...validFiles]);
    };

    const handleDeleteFile = (index) => {
        setUploadedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragging(true);
    };

    const toggleAmenity = (amenity) => {
        if (selectedAmenities.includes(amenity)) {
            setSelectedAmenities(selectedAmenities.filter((item) => item !== amenity));
        } else {
            setSelectedAmenities([...selectedAmenities, amenity]);
        }
    };

    const toggleLocationAdvantage = (advantage) => {
        if (selectedLocationAdvantages.includes(advantage)) {
            setSelectedLocationAdvantages(
                selectedLocationAdvantages.filter((item) => item !== advantage)
            );
        } else {
            setSelectedLocationAdvantages([...selectedLocationAdvantages, advantage]);
        }
    };


    const toggleWaterSupply = (advantage) => {
        if (selectedWaterSupply.includes(advantage)) {
            setSelectedWaterSupply(
                selectedWaterSupply.filter((item) => item !== advantage)
            );
        } else {
            setSelectedWaterSupply([...selectedWaterSupply, advantage]);
        }
    };

    const toggleSecurity = (advantage) => {
        if (selectedsecurity.includes(advantage)) {
            setSelectedSecurity(
                selectedsecurity.filter((item) => item !== advantage)
            );
        } else {
            setSelectedSecurity([...selectedsecurity, advantage]);
        }
    };

    const handleDragLeave = () => setDragging(false);

    const handleDrop = (event) => {
        event.preventDefault();
        setDragging(false);

        const files = Array.from(event.dataTransfer.files);

        const validFiles = files.filter(file =>
            file.size <= maxSize &&
            ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type)
        );

        const duplicateFiles = validFiles.filter(file =>
            uploadedFiles.some(existingFile => existingFile.name === file.name)
        );

        if (duplicateFiles.length > 0) {
            toast.error('You cannot upload duplicate images.');
            return;
        }

        if (uploadedFiles.length + validFiles.length > maxFiles) {
            toast.error(`You can upload a maximum of ${maxFiles} images.`);
            return;
        }

        setUploadedFiles(prevFiles => [...prevFiles, ...validFiles]);
    };

    const handleRemoveTag = (index, type) => {
        const updatedList = type === 'amenities'
            ? amenities.split(',').filter((_, i) => i !== index).join(',')
            : locationAdvantages.split(',').filter((_, i) => i !== index).join(',');

        type === 'amenities' ? setAmenities(updatedList) : setLocationAdvantages(updatedList);
    };

    const render1RKSection = () => {
        return (
            <div className="accordion-item">
                <div className="accordion-header" onClick={() => handleToggle("1RK")}>
                    <h3>Enter number of 1RK</h3>
                    <span className={openIndex === "1RK" ? 'accordion-icon open' : 'accordion-icon'}>+</span>
                </div>
                {openIndex === "1RK" && (
                    <div className="accordion-body">
                        {/* Built-up Area and Expected Price */}
                        <div className="post-input">
                            <label>Carpet Area (Sq.ft) & Expected Price</label>
                            {data.rkBuiltUpAreas.map((area, index) => (
                                <>
                                    <div key={index} className="carpet-add-remove" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="number"
                                                name={`rkBuiltUpAreas${index}`}
                                                placeholder="Enter Carpet Area"
                                                value={area.value}
                                                onChange={(e) => handleDynamicChange(e, "rkBuiltUpAreas", index, "value")}
                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`rkExpectedPrice${index}`}
                                                placeholder="Enter Expected Price"
                                                value={
                                                    area.expectedPrice && !isNaN(area.expectedPrice)
                                                        ? Number(area.expectedPrice).toLocaleString("en-IN")
                                                        : area.expectedPrice || ""
                                                }
                                                // onChange={(e) => handleDynamicChange(e, "rkBuiltUpAreas", index, "expectedPrice")}
                                                onChange={(e) => {
                                                    const plainNumber = e.target.value.replace(/,/g, '');
                                                    handleDynamicChange({ target: { value: plainNumber } }, "rkBuiltUpAreas", index, "expectedPrice");
                                                }}
                                            />
                                            <small style={{ fontSize: "12px", color: "#007bff", fontWeight: "600" }}>
                                                {area.expectedPrice ? `(${convertToWords(area.expectedPrice)} only)` : ""}
                                            </small>
                                        </div>
                                        <div style={{ marginTop: 10 }}>
                                            {index === data.rkBuiltUpAreas.length - 1 ? (
                                                <i
                                                    className="fa-solid fa-plus"
                                                    onClick={() => handleAddField("rkBuiltUpAreas")}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-minus"
                                                    onClick={() => handleRemoveField("rkBuiltUpAreas", index)}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            )}
                                        </div>
                                    </div>
                                </>
                            ))}
                        </div>
                        {/* Carpet Area Toggle */}
                        <div className="toggle-section">
                            {/* <div className="toggle-header" onClick={() => setShowCarpet(!showCarpet)}>
                                <label>Carpet Area (Sq.ft)</label>
                                <i className={`fa-solid ${showCarpet ? "fa-minus" : "fa-plus"}`}></i>
                            </div> */}
                            {/* {showCarpet && (
                                <div className="post-input">
                                    {data.rkCarpetAreas.map((area, index) => (
                                        <div key={index} className="carpet-add-remove">
                                            <input
                                                type="number"
                                                name={`rkCarpetArea${index}`}
                                                placeholder="Enter Carpet Area"
                                                value={area.value}
                                                onChange={(e) => handleDynamicChange(e, "rkCarpetAreas", index, "value")}
                                           
                                            />
                                            {index === data.rkCarpetAreas.length - 1 ? (
                                                <i
                                                    className="fa-solid fa-plus"
                                                    onClick={() => handleAddField("rkCarpetAreas")}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-minus"
                                                    onClick={() => handleRemoveField("rkCarpetAreas", index)}
                                                ></i>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )} */}
                        </div>

                        {/* Super Built-up Area Toggle */}
                        <div className="toggle-section">
                            {/* <div className="toggle-header" onClick={() => setShowSuperBuiltUp(!showSuperBuiltUp)}>
                                <label>Super build up area (Sq.ft)</label>
                                <i className={`fa-solid ${showSuperBuiltUp ? "fa-minus" : "fa-plus"}`}></i>
                            </div>
                            {showSuperBuiltUp && (
                                <div className="post-input">
                                    {data.rkSuperBuiltUpAreas.map((area, index) => (
                                        <div key={index} className="carpet-add-remove">
                                            <input
                                                type="number"
                                                name={`rkSuperBuiltUpAreas${index}`}
                                                placeholder="Enter Super Built-up Area"
                                                value={area.value}
                                                onChange={(e) => handleDynamicChange(e, "rkSuperBuiltUpAreas", index, "value")}

                                            />
                                            {index === superBuiltUpAreas.length - 1 ? (
                                               
                                                <i
                                                    className="fa-solid fa-plus"
                                                    onClick={() => handleAddField("rkSuperBuiltUpAreas")}
                                                ></i>
                                            ) : (
                                                
                                                <i
                                                    className="fa-solid fa-minus"
                                                    onClick={() => handleRemoveField("rkSuperBuiltUpAreas", index)}
                                                ></i>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )} */}
                        </div>

                        <div className="post-input">
                            <label>Balconies</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBalconies"
                                        value="0"
                                        id="balcony-0"
                                        checked={data.rkBalconies === "0"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-0">Without Balcony</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBalconies"
                                        value="1"
                                        id="balcony-1"
                                        checked={data.rkBalconies === "1"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-1">1 Balcony</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBalconies"
                                        value="2"
                                        id="balcony-2"
                                        checked={data.rkBalconies === "2"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-2">2 Balconies</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBalconies"
                                        value="3"
                                        id="balcony-3"
                                        checked={data.rkBalconies === "3"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-3">3 Balconies</label>
                                </div>
                            </div>

                            {!viewBalconiesMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBalconiesMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBalconiesMore && (
                                <div className="number-input">
                                    <label>Enter Number of Balconies</label>
                                    <input
                                        type="text"
                                        name="rkBalconies"
                                        value={data.rkBalconies}
                                        onChange={handleInputChange}
                                        onKeyDown={(e) => handleEnterPress(e, "rkBalconies")}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}
                            {errors.rkBalconies && <span className="error">This field is required*</span>}
                        </div>


                        {/* Bathrooms Section */}
                        <div className="post-input">
                            <label>Bathrooms</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBathrooms"
                                        value="1"
                                        id="bathroom-1"
                                        checked={data.rkBathrooms === "1"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bathroom-1">1 Bathroom</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBathrooms"
                                        value="2"
                                        id="bathroom-2"
                                        checked={data.rkBathrooms === "2"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bathroom-2">2 Bathrooms</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBathrooms"
                                        value="3"
                                        id="bathroom-3"
                                        checked={data.rkBathrooms === "3"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bathroom-3">3 Bathrooms</label>
                                </div>
                            </div>

                            {!viewBathroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBathroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBathroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bathrooms</label>
                                    <input
                                        type="number"
                                        name="rkBathrooms"
                                        value={data.rkBathrooms}
                                        onChange={handleInputChange}
                                        onKeyDown={(e) => handleEnterPress(e, "rkBathrooms")}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}
                            {errors.rkBathrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Furnish Status Section */}
                        <div className="post-input">
                            <label>Furnish Status</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkFurnishStatus"
                                        value="Furnished"
                                        id="furnish-furnished"
                                        checked={data.rkFurnishStatus === 'Furnished'}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-furnished">Furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkFurnishStatus"
                                        value="Unfurnished"
                                        id="furnish-unfurnished"
                                        checked={data.rkFurnishStatus === 'Unfurnished'}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-unfurnished">Un-furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkFurnishStatus"
                                        value="Semi-furnished"
                                        id="furnish-semi-furnished"
                                        checked={data.rkFurnishStatus === 'Semi-furnished'}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-semi-furnished">Semi-furnished</label>
                                </div>
                            </div>
                            {errors.rkFurnishStatus && <span className="error">This field is required*</span>}
                        </div>

                        {/* Condition of Flat Section */}
                        <div className="post-input">
                            <label>Condition of Flat</label>
                            <input
                                type="text"
                                name="rkConditionOfFlat"
                                value={data.rkConditionOfFlat}
                                onChange={handleInputChange}
                                placeholder="Enter condition of flat (Maintenance/Repair)"
                            />
                            {errors.rkConditionOfFlat && <span className="error">This field is required*</span>}
                        </div>


                        {/* Monthly Maintenance Section */}
                        <div className="post-input">
                            <label>Monthly Maintenance</label>
                            <input
                                type="number"
                                name="rkMonthlyMaintenance"
                                placeholder="Enter Monthly Maintenance"
                                value={data.rkMonthlyMaintenance}
                                onChange={handleInputChange}
                            />
                            {errors.rkMonthlyMaintenance && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price All Inclusive Section */}
                        <div className="post-input">
                            <label>Price all inclusive</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkPriceAllInclusive"
                                        value="Yes"
                                        id="price-all-inclusive-yes"
                                        checked={data.rkPriceAllInclusive === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkPriceAllInclusive"
                                        value="No"
                                        id="price-all-inclusive-no"
                                        checked={data.rkPriceAllInclusive === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-no">No</label>
                                </div>
                            </div>
                            {errors.rkPriceAllInclusive && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable Section */}
                        <div className="post-input">
                            <label>Price Negotiable</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkPriceNegotiable"
                                        value="Yes"
                                        id="price-negotiable-yes"
                                        checked={data.rkPriceNegotiable === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkPriceNegotiable"
                                        value="No"
                                        id="price-negotiable-no"
                                        checked={data.rkPriceNegotiable === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-no">No</label>
                                </div>
                            </div>
                            {errors.rkPriceNegotiable && <span className="error">This field is required*</span>}
                        </div>

                        {/* Preferred Cash Type Section */}
                        <div className="post-input">
                            <label>Preferred Cash Type</label>
                            <div className="checkbox-group">
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="rkPreferredCashType"
                                        value="Cash"
                                        id="cash-type-cash"
                                        checked={data.rkPreferredCashType.includes("Cash")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cash">Cash</label>
                                </div>
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="rkPreferredCashType"
                                        value="Cheque"
                                        id="cash-type-cheque"
                                        checked={data.rkPreferredCashType.includes("Cheque")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cheque">Cheque</label>
                                </div>
                            </div>
                            {errors.rkPreferredCashType && <span className="error">This field is required*</span>}
                        </div>

                        {/* Loan Facility Section */}
                        <div className="post-input">
                            <label>Loan Facility</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        id="loan-available"
                                        type="radio"
                                        name="rkLoanFacility"
                                        value="Available"
                                        checked={data.rkLoanFacility === "Available"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="loan-available">Available</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        id="loan-notavailable"
                                        type="radio"
                                        name="rkLoanFacility"
                                        value="Not Available"
                                        checked={data.rkLoanFacility === "Not Available"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="loan-notavailable">Not Available</label>
                                </div>
                            </div>
                            {errors.rkLoanFacility && <span className="error">This field is required*</span>}
                        </div>

                        {/* Are Property Documents Available Section */}

                        <div className="post-input">
                            <label>Floor plan</label>
                            <input
                                type='file'
                                name="rkFloorPlan"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                            {errors.rkFloorPlan && <span className="error">This field is required*</span>}
                        </div>
                        <div className="property-images">
                            <h3>Property Images</h3>

                            <div className="image-gallery">

                                <div className="image-container1">
                                    <img
                                        src={`https://100real.xyz/Images/Store/${data.rkFloorPlan}`}
                                        // alt={`Property Image ${index + 1}`}
                                        className="property-image"
                                    />

                                </div>

                            </div>

                        </div>
                    </div>
                )}
            </div>
        );
    };

    // 4BHK section
    const render1BHKSection = () => {
        return (
            <div className="accordion-item">
                <div className="accordion-header" onClick={() => handleToggle("1BHK")}>
                    <h3>Enter number of 1BHK</h3>
                    <span className={openIndex === "1BHK" ? 'accordion-icon open' : 'accordion-icon'}>+</span>
                </div>
                {openIndex === "1BHK" && (
                    <div className="accordion-body">
                        {/* Built-up Area and Expected Price */}
                        <div className="post-input">
                            <label>Carpet Area (Sq.ft) & Expected Price</label>
                            {data.bhk1BuiltUpAreas.map((area, index) => (
                                <>
                                    <div key={index} className="carpet-add-remove" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="number"
                                                name={`bhk1BuiltUpAreas${index}`}
                                                placeholder="Enter Carpet Area"
                                                value={area.value}
                                                onChange={(e) => handleDynamicChange(e, "bhk1BuiltUpAreas", index, "value")}
                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`bhk1ExpectedPrice${index}`}
                                                placeholder="Enter Expected Price"
                                                value={
                                                    area.expectedPrice && !isNaN(area.expectedPrice)
                                                        ? Number(area.expectedPrice).toLocaleString("en-IN")
                                                        : area.expectedPrice || ""
                                                }

                                                // onChange={(e) => handleDynamicChange(e, "bhk1BuiltUpAreas", index, "expectedPrice")}
                                                onChange={(e) => {
                                                    const plainNumber = e.target.value.replace(/,/g, '');
                                                    handleDynamicChange({ target: { value: plainNumber } }, "bhk1BuiltUpAreas", index, "expectedPrice");
                                                }}
                                            />
                                            <small style={{ fontSize: "12px", color: "#007bff", fontWeight: "600" }}>
                                                {area.expectedPrice ? `(${convertToWords(area.expectedPrice)} only)` : ""}
                                            </small>
                                        </div>
                                        <div style={{ marginTop: 10 }}>
                                            {index === data.bhk1BuiltUpAreas.length - 1 ? (
                                                <i
                                                    className="fa-solid fa-plus"
                                                    onClick={() => {
                                                        handleAddField("bhk1BuiltUpAreas");
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-minus"
                                                    onClick={() => {
                                                        handleRemoveField("bhk1BuiltUpAreas", index);
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            )}
                                        </div>
                                    </div>
                                </>
                            ))}
                        </div>


                        {/* Bedrooms Section */}
                        <div className="post-input">
                            <label>Bedrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3, 4].map((num) => (
                                    <div className="radio-option" key={`bedroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk1Bedrooms"
                                            value={num}
                                            id={`bedroom-${num}`}
                                            checked={data.bhk1Bedrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bedroom-${num}`}>{num} Bedroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1Bedrooms"
                                        value="jodi"
                                        id="bedroom-jodi"
                                        checked={data.bhk1Bedrooms === "jodi"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bedroom-jodi">Jodi</label>
                                </div>
                            </div>
                            {data.bhk1Bedrooms === "jodi" && (
                                <div className="jodi-bedroom-inputs">
                                    <label>Enter Jodi Bedrooms</label>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <input
                                            type="number"
                                            name="bhk1BedroomsJodi1"
                                            value={data.bhk1BedroomsJodi1 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 1"
                                            style={{ width: "100px" }}
                                        />
                                        <span>+</span>
                                        <input
                                            type="number"
                                            name="bhk1BedroomsJodi2"
                                            value={data.bhk1BedroomsJodi2 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 2"
                                            style={{ width: "100px" }}
                                        />
                                    </div>
                                </div>
                            )}
                            {data.bhk1Bedrooms !== "jodi" && !viewBedroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBedroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {data.bhk1Bedrooms !== "jodi" && viewBedroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bedrooms</label>
                                    <input
                                        type="text"
                                        name="bhk1Bedrooms"
                                        value={data.bhk1Bedrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}
                            {errors.bhk1Bedrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Balconies Section */}
                        <div className="post-input">
                            <label>Balconies</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1Balconies"
                                        value="0"
                                        id="balcony-0"
                                        checked={data.bhk1Balconies === "0"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-0">Without Balcony</label>
                                </div>
                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`balcony-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk1Balconies"
                                            value={num}
                                            id={`balcony-${num}`}
                                            checked={data.bhk1Balconies === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`balcony-${num}`}>{num} Balcony{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBalconiesMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBalconiesMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBalconiesMore && (
                                <div className="number-input">
                                    <label>Enter Number of Balconies</label>
                                    <input
                                        type="number"
                                        name="bhk1Balconies"
                                        value={data.bhk1Balconies}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"

                                    />
                                </div>
                            )}
                            {errors.bhk1Balconies && <span className="error">This field is required*</span>}
                        </div>

                        {/* Bathrooms Section */}
                        <div className="post-input">
                            <label>Bathrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`bathroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk1Bathrooms"
                                            value={num}
                                            id={`bathroom-${num}`}
                                            checked={data.bhk1Bathrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bathroom-${num}`}>{num} Bathroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBathroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBathroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBathroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bathrooms</label>
                                    <input
                                        type="number"
                                        name="bhk1Bathrooms"
                                        value={data.bhk1Bathrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"

                                    />
                                </div>
                            )}
                            {errors.bhk1Bathrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Furnish Status */}
                        <div className="post-input">
                            <label>Furnish Status</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1FurnishStatus"
                                        value="Furnished"
                                        id="furnish-furnished"
                                        checked={data.bhk1FurnishStatus === "Furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-furnished">Furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1FurnishStatus"
                                        value="Unfurnished"
                                        id="furnish-unfurnished"
                                        checked={data.bhk1FurnishStatus === "Unfurnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-unfurnished">Un-furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1FurnishStatus"
                                        value="Semi-furnished"
                                        id="furnish-semi-furnished"
                                        checked={data.bhk1FurnishStatus === "Semi-furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-semi-furnished">Semi-furnished</label>
                                </div>
                            </div>
                            {errors.bhk1FurnishStatus && <span className="error">This field is required*</span>}
                        </div>

                        {/* Condition of Flat */}
                        <div className="post-input">
                            <label>Condition of Flat</label>
                            <input
                                type="text"
                                name="bhk1ConditionOfFlat"
                                value={data.bhk1ConditionOfFlat}
                                onChange={handleInputChange}
                                placeholder="Enter condition of flat (Maintenance/Repair)"
                            />
                            {errors.bhk1ConditionOfFlat && <span className="error">This field is required*</span>}
                        </div>

                        {/* Monthly Maintenance */}
                        <div className="post-input">
                            <label>Monthly Maintenance</label>
                            <input
                                type="number"
                                name="bhk1MonthlyMaintenance"
                                value={data.bhk1MonthlyMaintenance}
                                onChange={handleInputChange}
                                placeholder="Enter Monthly Maintenance"
                            />
                            {errors.bhk1MonthlyMaintenance && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price all inclusive</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1PriceAllInclusive"
                                        value="Yes"
                                        id="price-all-inclusive-yes"
                                        checked={data.bhk1PriceAllInclusive === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1PriceAllInclusive"
                                        value="No"
                                        id="price-all-inclusive-no"
                                        checked={data.bhk1PriceAllInclusive === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-no">No</label>
                                </div>
                            </div>
                            {errors.bhk1PriceAllInclusive && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price Negotiable</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1PriceNegotiable"
                                        value="Yes"
                                        id="price-negotiable-yes"
                                        checked={data.bhk1PriceNegotiable === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1PriceNegotiable"
                                        value="No"
                                        id="price-negotiable-no"
                                        checked={data.bhk1PriceNegotiable === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-no">No</label>
                                </div>
                            </div>
                            {errors.bhk1PriceNegotiable && <span className="error">This field is required*</span>}
                        </div>

                        {/* Preferred Cash Type */}
                        <div className="post-input">
                            <label>Preferred Cash Type</label>
                            <div className="checkbox-group">
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk1PreferredCashType"
                                        value="Cash"
                                        id="cash-type-cash"
                                        checked={data.bhk1PreferredCashType.includes("Cash")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cash">Cash</label>
                                </div>
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk1PreferredCashType"
                                        value="Cheque"
                                        id="cash-type-cheque"
                                        checked={data.bhk1PreferredCashType.includes("Cheque")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cheque">Cheque</label>
                                </div>
                            </div>
                            {errors.bhk1PreferredCashType && <span className="error">This field is required*</span>}
                        </div>


                        <div className="post-input">
                            <label>Floor plan</label>
                            <input
                                type='file'
                                name="bhk1FloorPlan"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                            {errors.bhk1FloorPlan && <span className="error">This field is required*</span>}
                        </div>

                        <div className="property-images">
                            <h3>Property Images</h3>

                            <div className="image-gallery">

                                <div className="image-container1">
                                    <img
                                        src={`https://100real.xyz/Images/Store/${data.bhk1FloorPlan}`}
                                        // alt={`Property Image ${index + 1}`}
                                        className="property-image"
                                    />

                                </div>

                            </div>

                        </div>
                    </div>
                )}
            </div>
        );
    };

    // 2BHK section
    const render2BHKSection = () => {
        return (
            <div className="accordion-item">
                <div className="accordion-header" onClick={() => handleToggle("2BHK")}>
                    <h3>Enter number of 2BHK</h3>
                    <span className={openIndex === "2BHK" ? 'accordion-icon open' : 'accordion-icon'}>+</span>
                </div>
                {openIndex === "2BHK" && (
                    <div className="accordion-body">
                        {/* Built-up Area and Expected Price */}
                        <div className="post-input">
                            <label>Carpet Area (Sq.ft) & Expected Price</label>
                            {data.bhk2BuiltUpAreas.map((area, index) => (
                                <>
                                    <div key={index} className="carpet-add-remove" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="number"
                                                name={`bhk2BuiltUpAreas${index}`}
                                                placeholder="Enter Carpet Area"
                                                value={area.value}
                                                onChange={(e) => handleDynamicChange(e, "bhk2BuiltUpAreas", index, "value")}

                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`bhk2ExpectedPrice${index}`}
                                                placeholder="Enter Expected Price"
                                                value={
                                                    area.expectedPrice && !isNaN(area.expectedPrice)
                                                        ? Number(area.expectedPrice).toLocaleString("en-IN")
                                                        : area.expectedPrice || ""
                                                }

                                                onChange={(e) => {
                                                    const plainNumber = e.target.value.replace(/,/g, '');
                                                    handleDynamicChange({ target: { value: plainNumber } }, "bhk2BuiltUpAreas", index, "expectedPrice");
                                                }}
                                            />
                                            <small style={{ fontSize: "12px", color: "#007bff", fontWeight: "600" }}>
                                                {area.expectedPrice ? `(${convertToWords(area.expectedPrice)} only)` : ""}
                                            </small>
                                        </div>
                                        <div style={{ marginTop: 10 }}>
                                            {index === data.bhk2BuiltUpAreas.length - 1 ? (
                                                <i
                                                    className="fa-solid fa-plus"
                                                    onClick={() => {
                                                        handleAddField("bhk2BuiltUpAreas");
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-minus"
                                                    onClick={() => {
                                                        handleRemoveField("bhk2BuiltUpAreas", index);
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            )}
                                        </div>
                                    </div>
                                </>
                            ))}
                        </div>


                        {/* Bedrooms Section */}
                        <div className="post-input">
                            <label>Bedrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3, 4].map((num) => (
                                    <div className="radio-option" key={`bedroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk2Bedrooms"
                                            value={num}
                                            id={`bedroom-${num}`}
                                            checked={data.bhk2Bedrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bedroom-${num}`}>{num} Bedroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2Bedrooms"
                                        value="jodi"
                                        id="bedroom-jodi"
                                        checked={data.bhk2Bedrooms === "jodi"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bedroom-jodi">Jodi</label>
                                </div>
                            </div>

                            {data.bhk2Bedrooms === "jodi" && (
                                <div className="jodi-bedroom-inputs">
                                    <label>Enter Jodi Bedrooms</label>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <input
                                            type="number"
                                            name="bhk2BedroomsJodi1"
                                            value={data.bhk2BedroomsJodi1 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 1"
                                            style={{ width: "100px" }}
                                        />
                                        <span>+</span>
                                        <input
                                            type="number"
                                            name="bhk2BedroomsJodi2"
                                            value={data.bhk2BedroomsJodi2 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 2"
                                            style={{ width: "100px" }}
                                        />
                                    </div>
                                </div>
                            )}

                            {data.bhk2Bedrooms !== "jodi" && !viewBedroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBedroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {data.bhk2Bedrooms !== "jodi" && viewBedroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bedrooms</label>
                                    <input
                                        type="text"
                                        name="bhk2Bedrooms"
                                        value={data.bhk2Bedrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}
                            {errors.bhk2Bedrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Balconies Section */}
                        <div className="post-input">
                            <label>Balconies</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2Balconies"
                                        value="0"
                                        id="balcony-0"
                                        checked={data.bhk2Balconies === "0"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-0">Without Balcony</label>
                                </div>
                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`balcony-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk2Balconies"
                                            value={num}
                                            id={`balcony-${num}`}
                                            checked={data.bhk2Balconies === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`balcony-${num}`}>{num} Balcony{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBalconiesMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBalconiesMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBalconiesMore && (
                                <div className="number-input">
                                    <label>Enter Number of Balconies</label>
                                    <input
                                        type="number"
                                        name="bhk2Balconies"
                                        value={data.bhk2Balconies}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"

                                    />
                                </div>
                            )}
                            {errors.bhk2Balconies && <span className="error">This field is required*</span>}
                        </div>

                        {/* Bathrooms Section */}
                        <div className="post-input">
                            <label>Bathrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`bathroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk2Bathrooms"
                                            value={num}
                                            id={`bathroom-${num}`}
                                            checked={data.bhk2Bathrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bathroom-${num}`}>{num} Bathroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBathroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBathroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBathroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bathrooms</label>
                                    <input
                                        type="number"
                                        name="bhk2Bathrooms"
                                        value={data.bhk2Bathrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"

                                    />
                                </div>
                            )}
                            {errors.bhk2Bathrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Furnish Status */}
                        <div className="post-input">
                            <label>Furnish Status</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2FurnishStatus"
                                        value="Furnished"
                                        id="furnish-furnished"
                                        checked={data.bhk2FurnishStatus === "Furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-furnished">Furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2FurnishStatus"
                                        value="Unfurnished"
                                        id="furnish-unfurnished"
                                        checked={data.bhk2FurnishStatus === "Unfurnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-unfurnished">Un-furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2FurnishStatus"
                                        value="Semi-furnished"
                                        id="furnish-semi-furnished"
                                        checked={data.bhk2FurnishStatus === "Semi-furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-semi-furnished">Semi-furnished</label>
                                </div>
                            </div>
                            {errors.bhk2FurnishStatus && <span className="error">This field is required*</span>}
                        </div>

                        {/* Condition of Flat */}
                        <div className="post-input">
                            <label>Condition of Flat</label>
                            <input
                                type="text"
                                name="bhk2ConditionOfFlat"
                                value={data.bhk2ConditionOfFlat}
                                onChange={handleInputChange}
                                placeholder="Enter condition of flat (Maintenance/Repair)"
                            />
                            {errors.bhk2ConditionOfFlat && <span className="error">This field is required*</span>}
                        </div>


                        {/* Monthly Maintenance */}
                        <div className="post-input">
                            <label>Monthly Maintenance</label>
                            <input
                                type="number"
                                name="bhk2MonthlyMaintenance"
                                value={data.bhk2MonthlyMaintenance}
                                onChange={handleInputChange}
                                placeholder="Enter Monthly Maintenance"
                            />
                            {errors.bhk2MonthlyMaintenance && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price all inclusive</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2PriceAllInclusive"
                                        value="Yes"
                                        id="price-all-inclusive-yes"
                                        checked={data.bhk2PriceAllInclusive === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2PriceAllInclusive"
                                        value="No"
                                        id="price-all-inclusive-no"
                                        checked={data.bhk2PriceAllInclusive === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-no">No</label>
                                </div>
                            </div>
                            {errors.bhk2PriceAllInclusive && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price Negotiable</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2PriceNegotiable"
                                        value="Yes"
                                        id="price-negotiable-yes"
                                        checked={data.bhk2PriceNegotiable === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2PriceNegotiable"
                                        value="No"
                                        id="price-negotiable-no"
                                        checked={data.bhk2PriceNegotiable === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-no">No</label>
                                </div>
                            </div>
                            {errors.bhk2PriceNegotiable && <span className="error">This field is required*</span>}
                        </div>

                        {/* Preferred Cash Type */}
                        <div className="post-input">
                            <label>Preferred Cash Type</label>
                            <div className="checkbox-group">
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk2PreferredCashType"
                                        value="Cash"
                                        id="cash-type-cash"
                                        checked={data.bhk2PreferredCashType.includes("Cash")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cash">Cash</label>
                                </div>
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk2PreferredCashType"
                                        value="Cheque"
                                        id="cash-type-cheque"
                                        checked={data.bhk2PreferredCashType.includes("Cheque")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cheque">Cheque</label>
                                </div>
                            </div>
                            {errors.bhk2PreferredCashType && <span className="error">This field is required*</span>}
                        </div>


                        <div className="post-input">
                            <label>Floor plan</label>
                            <input
                                type='file'
                                name="bhk2FloorPlan"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                            {errors.bhk2FloorPlan && <span className="error">This field is required*</span>}
                        </div>
                        <div className="property-images">
                            <h3>Property Images</h3>

                            <div className="image-gallery">

                                <div className="image-container1">
                                    <img
                                        src={`https://100real.xyz/Images/Store/${data.bhk2FloorPlan}`}
                                        // alt={`Property Image ${index + 1}`}
                                        className="property-image"
                                    />

                                </div>

                            </div>

                        </div>
                    </div>
                )}
            </div>
        );
    };

    // 3BHK section
    const render3BHKSection = () => {
        return (
            <div className="accordion-item">
                <div className="accordion-header" onClick={() => handleToggle("3BHK")}>
                    <h3>Enter number of 3BHK</h3>
                    <span className={openIndex === "3BHK" ? 'accordion-icon open' : 'accordion-icon'}>+</span>
                </div>
                {openIndex === "3BHK" && (
                    <div className="accordion-body">
                        {/* Built-up Area and Expected Price */}
                        <div className="post-input">
                            <label>Carpet Area (Sq.ft) & Expected Price</label>
                            {data.bhk3BuiltUpAreas.map((area, index) => (
                                <>
                                    <div key={index} className="carpet-add-remove" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="number"
                                                name={`bhk3BuiltUpAreas${index}`}
                                                placeholder="Enter Carpet Area"
                                                value={area.value}
                                                onChange={(e) => handleDynamicChange(e, "bhk3BuiltUpAreas", index, "value")}

                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`bhk3ExpectedPrice${index}`}
                                                placeholder="Enter Expected Price"
                                                value={
                                                    area.expectedPrice && !isNaN(area.expectedPrice)
                                                        ? Number(area.expectedPrice).toLocaleString("en-IN")
                                                        : area.expectedPrice || ""
                                                }
                                                onChange={(e) => {
                                                    const plainNumber = e.target.value.replace(/,/g, '');
                                                    handleDynamicChange({ target: { value: plainNumber } }, "bhk3BuiltUpAreas", index, "expectedPrice");
                                                }}

                                            />
                                            <small style={{ fontSize: "12px", color: "#007bff", fontWeight: "600" }}>
                                                {area.expectedPrice ? `(${convertToWords(area.expectedPrice)} only)` : ""}
                                            </small>
                                        </div>
                                        <div style={{ marginTop: 10 }}>
                                            {index === data.bhk3BuiltUpAreas.length - 1 ? (
                                                <i
                                                    className="fa-solid fa-plus"
                                                    onClick={() => {
                                                        handleAddField("bhk3BuiltUpAreas");
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-minus"
                                                    onClick={() => {
                                                        handleRemoveField("bhk3BuiltUpAreas", index);
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            )}
                                        </div>
                                    </div>

                                </>
                            ))}
                        </div>


                        {/* Bedrooms Section */}
                        <div className="post-input">
                            <label>Bedrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3, 4].map((num) => (
                                    <div className="radio-option" key={`bedroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk3Bedrooms"
                                            value={num}
                                            id={`bedroom-${num}`}
                                            checked={data.bhk3Bedrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bedroom-${num}`}>{num} Bedroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3Bedrooms"
                                        value="jodi"
                                        id="bedroom-jodi"
                                        checked={data.bhk3Bedrooms === "jodi"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bedroom-jodi">Jodi</label>
                                </div>
                            </div>

                            {data.bhk3Bedrooms === "jodi" && (
                                <div className="jodi-bedroom-inputs">
                                    <label>Enter Jodi Bedrooms</label>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <input
                                            type="number"
                                            name="bhk3BedroomsJodi1"
                                            value={data.bhk3BedroomsJodi1 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 1"
                                            style={{ width: "100px" }}
                                        />
                                        <span>+</span>
                                        <input
                                            type="number"
                                            name="bhk3BedroomsJodi2"
                                            value={data.bhk3BedroomsJodi2 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 2"
                                            style={{ width: "100px" }}
                                        />
                                    </div>
                                </div>
                            )}

                            {data.bhk3Bedrooms !== "jodi" && !viewBedroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBedroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}


                            {data.bhk3Bedrooms !== "jodi" && viewBedroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bedrooms</label>
                                    <input
                                        type="text"
                                        name="bhk3Bedrooms"
                                        value={data.bhk3Bedrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}
                            {errors.bhk3Bedrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Balconies Section */}
                        <div className="post-input">
                            <label>Balconies</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3Balconies"
                                        value="0"
                                        id="balcony-0"
                                        checked={data.bhk3Balconies === "0"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-0">Without Balcony</label>
                                </div>
                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`balcony-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk3Balconies"
                                            value={num}
                                            id={`balcony-${num}`}
                                            checked={data.bhk3Balconies === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`balcony-${num}`}>{num} Balcony{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBalconiesMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBalconiesMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBalconiesMore && (
                                <div className="number-input">
                                    <label>Enter Number of Balconies</label>
                                    <input
                                        type="number"
                                        name="bhk3Balconies"
                                        value={data.bhk3Balconies}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"

                                    />
                                </div>
                            )}
                            {errors.bhk3Balconies && <span className="error">This field is required*</span>}
                        </div>

                        {/* Bathrooms Section */}
                        <div className="post-input">
                            <label>Bathrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`bathroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk3Bathrooms"
                                            value={num}
                                            id={`bathroom-${num}`}
                                            checked={data.bhk3Bathrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bathroom-${num}`}>{num} Bathroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBathroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBathroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBathroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bathrooms</label>
                                    <input
                                        type="number"
                                        name="bhk3Bathrooms"
                                        value={data.bhk3Bathrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"

                                    />
                                </div>
                            )}
                            {errors.bhk3Bathrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Furnish Status */}
                        <div className="post-input">
                            <label>Furnish Status</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3FurnishStatus"
                                        value="Furnished"
                                        id="furnish-furnished"
                                        checked={data.bhk3FurnishStatus === "Furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-furnished">Furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3FurnishStatus"
                                        value="Unfurnished"
                                        id="furnish-unfurnished"
                                        checked={data.bhk3FurnishStatus === "Unfurnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-unfurnished">Un-furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3FurnishStatus"
                                        value="Semi-furnished"
                                        id="furnish-semi-furnished"
                                        checked={data.bhk3FurnishStatus === "Semi-furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-semi-furnished">Semi-furnished</label>
                                </div>
                            </div>
                            {errors.bhk3FurnishStatus && <span className="error">This field is required*</span>}
                        </div>

                        {/* Condition of Flat */}
                        <div className="post-input">
                            <label>Condition of Flat</label>
                            <input
                                type="text"
                                name="bhk3ConditionOfFlat"
                                value={data.bhk3ConditionOfFlat}
                                onChange={handleInputChange}
                                placeholder="Enter condition of flat (Maintenance/Repair)"
                            />
                            {errors.bhk3ConditionOfFlat && <span className="error">This field is required*</span>}
                        </div>


                        {/* Monthly Maintenance */}
                        <div className="post-input">
                            <label>Monthly Maintenance</label>
                            <input
                                type="number"
                                name="bhk3MonthlyMaintenance"
                                value={data.bhk3MonthlyMaintenance}
                                onChange={handleInputChange}
                                placeholder="Enter Monthly Maintenance"
                            />
                            {errors.bhk3MonthlyMaintenance && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price all inclusive</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3PriceAllInclusive"
                                        value="Yes"
                                        id="price-all-inclusive-yes"
                                        checked={data.bhk3PriceAllInclusive === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3PriceAllInclusive"
                                        value="No"
                                        id="price-all-inclusive-no"
                                        checked={data.bhk3PriceAllInclusive === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-no">No</label>
                                </div>
                            </div>
                            {errors.bhk3PriceAllInclusive && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price Negotiable</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3PriceNegotiable"
                                        value="Yes"
                                        id="price-negotiable-yes"
                                        checked={data.bhk3PriceNegotiable === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3PriceNegotiable"
                                        value="No"
                                        id="price-negotiable-no"
                                        checked={data.bhk3PriceNegotiable === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-no">No</label>
                                </div>
                            </div>
                            {errors.bhk3PriceNegotiable && <span className="error">This field is required*</span>}
                        </div>

                        {/* Preferred Cash Type */}
                        <div className="post-input">
                            <label>Preferred Cash Type</label>
                            <div className="checkbox-group">
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk3PreferredCashType"
                                        value="Cash"
                                        id="cash-type-cash"
                                        checked={data.bhk3PreferredCashType.includes("Cash")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cash">Cash</label>
                                </div>
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk3PreferredCashType"
                                        value="Cheque"
                                        id="cash-type-cheque"
                                        checked={data.bhk3PreferredCashType.includes("Cheque")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cheque">Cheque</label>
                                </div>
                            </div>
                            {errors.bhk3PreferredCashType && <span className="error">This field is required*</span>}
                        </div>


                        <div className="post-input">
                            <label>Floor plan</label>
                            <input
                                type='file'
                                name="bhk3FloorPlan"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                            {errors.bhk3FloorPlan && <span className="error">This field is required*</span>}
                        </div>
                        <div className="property-images">
                            <h3>Property Images</h3>

                            <div className="image-gallery">

                                <div className="image-container1">
                                    <img
                                        src={`https://100real.xyz/Images/Store/${data.bhk3FloorPlan}`}
                                        // alt={`Property Image ${index + 1}`}
                                        className="property-image"
                                    />

                                </div>

                            </div>

                        </div>
                    </div>
                )}
            </div>
        );
    };

    // 4BHK section
    const render4BHKSection = () => {
        return (
            <div className="accordion-item">
                <div className="accordion-header" onClick={() => handleToggle("4BHK")}>
                    <h3>Enter number of 4BHK</h3>
                    <span className={openIndex === "4BHK" ? 'accordion-icon open' : 'accordion-icon'}>+</span>
                </div>
                {openIndex === "4BHK" && (
                    <div className="accordion-body">
                        {/* Built-up Area and Expected Price */}
                        <div className="post-input">
                            <label> Carpet Area (Sq.ft) & Expected Price</label>
                            {data.bhk4BuiltUpAreas.map((area, index) => (
                                <>
                                    <div key={index} className="carpet-add-remove" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="number"
                                                name={`bhk4BuiltUpAreas${index}`}
                                                placeholder="Enter Carpet Area"
                                                value={area.value}
                                                onChange={(e) => handleDynamicChange(e, "bhk4BuiltUpAreas", index, "value")}

                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`bhk4ExpectedPrice${index}`}
                                                placeholder="Enter Expected Price"
                                                value={
                                                    area.expectedPrice && !isNaN(area.expectedPrice)
                                                        ? Number(area.expectedPrice).toLocaleString("en-IN")
                                                        : area.expectedPrice || ""
                                                }
                                                onChange={(e) => {
                                                    const plainNumber = e.target.value.replace(/,/g, '');
                                                    handleDynamicChange({ target: { value: plainNumber } }, "bhk4BuiltUpAreas", index, "expectedPrice");
                                                }}

                                            />
                                            <small style={{ fontSize: "12px", color: "#007bff", fontWeight: "600" }}>
                                                {area.expectedPrice ? `(${convertToWords(area.expectedPrice)} only)` : ""}
                                            </small>
                                        </div>
                                        <div style={{ marginTop: 10 }}>
                                            {index === data.bhk4BuiltUpAreas.length - 1 ? (
                                                <i
                                                    className="fa-solid fa-plus"
                                                    onClick={() => {
                                                        handleAddField("bhk4BuiltUpAreas");
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-minus"
                                                    onClick={() => {
                                                        handleRemoveField("bhk4BuiltUpAreas", index);
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            )}
                                        </div>
                                    </div>

                                </>
                            ))}
                        </div>
                        {/* Carpet Area Toggle */}


                        {/* Bedrooms Section */}
                        <div className="post-input">
                            <label>Bedrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3, 4].map((num) => (
                                    <div className="radio-option" key={`bedroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk4Bedrooms"
                                            value={num}
                                            id={`bedroom-${num}`}
                                            checked={data.bhk4Bedrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bedroom-${num}`}>{num} Bedroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4Bedrooms"
                                        value="jodi"
                                        id="bedroom-jodi"
                                        checked={data.bhk4Bedrooms === "jodi"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bedroom-jodi">Jodi</label>
                                </div>
                            </div>

                            {data.bhk4Bedrooms === "jodi" && (
                                <div className="jodi-bedroom-inputs">
                                    <label>Enter Jodi Bedrooms</label>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <input
                                            type="number"
                                            name="bhk4BedroomsJodi1"
                                            value={data.bhk4BedroomsJodi1 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 1"
                                            style={{ width: "100px" }}
                                        />
                                        <span>+</span>
                                        <input
                                            type="number"
                                            name="bhk4BedroomsJodi2"
                                            value={data.bhk4BedroomsJodi2 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 2"
                                            style={{ width: "100px" }}
                                        />
                                    </div>
                                </div>
                            )}

                            {data.bhk4Bedrooms !== "jodi" && !viewBedroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBedroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {data.bhk4Bedrooms !== "jodi" && viewBedroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bedrooms</label>
                                    <input
                                        type="text"
                                        name="bhk4Bedrooms"
                                        value={data.bhk4Bedrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}
                            {errors.bhk4Bedrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Balconies Section */}
                        <div className="post-input">
                            <label>Balconies</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4Balconies"
                                        value="0"
                                        id="balcony-0"
                                        checked={data.bhk4Balconies === "0"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-0">Without Balcony</label>
                                </div>
                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`balcony-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk4Balconies"
                                            value={num}
                                            id={`balcony-${num}`}
                                            checked={data.bhk4Balconies === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`balcony-${num}`}>{num} Balcony{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBalconiesMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBalconiesMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBalconiesMore && (
                                <div className="number-input">
                                    <label>Enter Number of Balconies</label>
                                    <input
                                        type="number"
                                        name="bhk4Balconies"
                                        value={data.bhk4Balconies}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"

                                    />
                                </div>
                            )}
                            {errors.bhk4Balconies && <span className="error">This field is required*</span>}
                        </div>

                        {/* Bathrooms Section */}
                        <div className="post-input">
                            <label>Bathrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`bathroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk4Bathrooms"
                                            value={num}
                                            id={`bathroom-${num}`}
                                            checked={data.bhk4Bathrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bathroom-${num}`}>{num} Bathroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBathroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBathroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBathroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bathrooms</label>
                                    <input
                                        type="number"
                                        name="bhk4Bathrooms"
                                        value={data.bhk4Bathrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"

                                    />
                                </div>
                            )}
                            {errors.bhk4Bathrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Furnish Status */}
                        <div className="post-input">
                            <label>Furnish Status</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4FurnishStatus"
                                        value="Furnished"
                                        id="furnish-furnished"
                                        checked={data.bhk4FurnishStatus === "Furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-furnished">Furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4FurnishStatus"
                                        value="Unfurnished"
                                        id="furnish-unfurnished"
                                        checked={data.bhk4FurnishStatus === "Unfurnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-unfurnished">Un-furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4FurnishStatus"
                                        value="Semi-furnished"
                                        id="furnish-semi-furnished"
                                        checked={data.bhk4FurnishStatus === "Semi-furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-semi-furnished">Semi-furnished</label>
                                </div>
                            </div>
                            {errors.bhk4FurnishStatus && <span className="error">This field is required*</span>}
                        </div>

                        {/* Condition of Flat */}
                        <div className="post-input">
                            <label>Condition of Flat</label>
                            <input
                                type="text"
                                name="bhk4ConditionOfFlat"
                                value={data.bhk4ConditionOfFlat}
                                onChange={handleInputChange}
                                placeholder="Enter condition of flat (Maintenance/Repair)"
                            />
                            {errors.bhk4ConditionOfFlat && <span className="error">This field is required*</span>}
                        </div>


                        {/* Monthly Maintenance */}
                        <div className="post-input">
                            <label>Monthly Maintenance</label>
                            <input
                                type="number"
                                name="bhk4MonthlyMaintenance"
                                value={data.bhk4MonthlyMaintenance}
                                onChange={handleInputChange}
                                placeholder="Enter Monthly Maintenance"
                            />
                            {errors.bhk4MonthlyMaintenance && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price all inclusive</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4PriceAllInclusive"
                                        value="Yes"
                                        id="price-all-inclusive-yes"
                                        checked={data.bhk4PriceAllInclusive === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4PriceAllInclusive"
                                        value="No"
                                        id="price-all-inclusive-no"
                                        checked={data.bhk4PriceAllInclusive === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-no">No</label>
                                </div>
                            </div>
                            {errors.bhk4PriceAllInclusive && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price Negotiable</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4PriceNegotiable"
                                        value="Yes"
                                        id="price-negotiable-yes"
                                        checked={data.bhk4PriceNegotiable === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4PriceNegotiable"
                                        value="No"
                                        id="price-negotiable-no"
                                        checked={data.bhk4PriceNegotiable === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-no">No</label>
                                </div>
                            </div>
                            {errors.bhk4PriceNegotiable && <span className="error">This field is required*</span>}
                        </div>

                        {/* Preferred Cash Type */}
                        <div className="post-input">
                            <label>Preferred Cash Type</label>
                            <div className="checkbox-group">
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk4PreferredCashType"
                                        value="Cash"
                                        id="cash-type-cash"
                                        checked={data.bhk4PreferredCashType.includes("Cash")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cash">Cash</label>
                                </div>
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk4PreferredCashType"
                                        value="Cheque"
                                        id="cash-type-cheque"
                                        checked={data.bhk4PreferredCashType.includes("Cheque")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cheque">Cheque</label>
                                </div>
                            </div>
                            {errors.bhk4PreferredCashType && <span className="error">This field is required*</span>}
                        </div>


                        <div className="post-input">
                            <label>Floor plan</label>
                            <input
                                type='file'
                                name="bhk4FloorPlan"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                            {errors.bhk4FloorPlan && <span className="error">This field is required*</span>}
                        </div>
                        <div className="property-images">
                            <h3>Property Images</h3>

                            <div className="image-gallery">

                                <div className="image-container1">
                                    <img
                                        src={`https://100real.xyz/Images/Store/${data.bhk4FloorPlan}`}
                                        // alt={`Property Image ${index + 1}`}
                                        className="property-image"
                                    />

                                </div>

                            </div>

                        </div>
                    </div>
                )}
            </div>
        );
    };


    const handleInputChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        setData((prevState) => {
            if (type === "file") {
                return { ...prevState, [name]: files[0] };
            }
            if (type === "checkbox") {
                const updatedArray = checked
                    ? [...prevState[name], value]
                    : prevState[name].filter((item) => item !== value);
                return { ...prevState, [name]: updatedArray };
            }
            return { ...prevState, [name]: value };
        });

        if (errors[name]) {
            setErrors((prevErrors) => {
                const { [name]: removedError, ...restErrors } = prevErrors;
                return restErrors;
            });
        }
    };



    const fetchData = async () => {
        try {
            const response = await fetch(`https://100real.xyz/rentresident/getsingleproperty/${id}`);
            if (!response.ok) throw new Error("Failed to fetch data");
            const res = await response.json();
            console.log(res);

            // Parse JSON strings safely
            const parseJSON = (field, fallback = []) => {
                try {
                    return typeof field === "string" ? JSON.parse(field) : field || fallback;
                } catch {
                    return fallback;
                }
            };

            // Parse all fields
            const parsedData = {
                ...res,
                amenities: parseJSON(res.amenities),
                locationAdvantage: parseJSON(res.locationAdvantage),
                locationAdvantages: parseJSON(res.locationAdvantage), // alias for convenience
                formImages: parseJSON(res.formImages),
                carpetArea: parseJSON(res.carpetArea),
                flatType: parseJSON(res.flatType),
                security: parseJSON(res.security),
                water_supply: parseJSON(res.water_supply),
            };

            // Filter out flatTypes with valid builtUpAreas
            const validFlatTypes = parsedData.flatType.filter(flat =>
                Array.isArray(flat.builtUpAreas) &&
                flat.builtUpAreas.some(area => area.value?.trim() !== "")
            );

            const extractFlatData = (flatType, prefix) => {
                const flatData = validFlatTypes.find(flat => flat.type === flatType);
                return flatData ? {
                    [`${prefix}BuiltUpAreas`]: flatData.builtUpAreas?.map(item => ({
                        value: item.value || "",
                        expectedPrice: item.expectedPrice || "",
                        showMinus: false,
                    })) || [],
                    [`${prefix}CarpetAreas`]: flatData.carpetAreas || [{ value: "", showMinus: false }],
                    [`${prefix}SuperBuiltUpAreas`]: flatData.superBuiltUpAreas || [{ value: "", showMinus: false }],
                    [`${prefix}Bedrooms`]: flatData.bedrooms || "",
                    [`${prefix}Balconies`]: flatData.balconies || "",
                    [`${prefix}Bathrooms`]: flatData.bathrooms || "",
                    [`${prefix}BedroomsJodi1`]: flatData.jodi1 || "",         // ✅ Fix here
                    [`${prefix}BedroomsJodi2`]: flatData.jodi2 || "",
                    [`${prefix}FurnishStatus`]: flatData.furnishStatus || "",
                    [`${prefix}ConditionOfFlat`]: flatData.conditionOfFlat || "",
                    [`${prefix}MonthlyMaintenance`]: flatData.monthlyMaintenance || "",
                    [`${prefix}PriceAllInclusive`]: flatData.priceAllInclusive || "",
                    [`${prefix}PriceNegotiable`]: flatData.priceNegotiable || "",
                    [`${prefix}PreferredCashType`]: flatData.preferredCashType || [],
                    [`${prefix}LoanFacility`]: flatData.loanFacility || "",
                    [`${prefix}DocumentsAvailable`]: flatData.documentsAvailable || "",
                    [`${prefix}FloorPlan`]: flatData.floorPlan || "",
                } : {};
            };

            // Set to state
            setData(prevData => ({
                ...prevData,
                ...parsedData,
                flatType: validFlatTypes.map(ft => ft.type), // just the valid types
                ...extractFlatData("1RK", "rk"),
                ...extractFlatData("1BHK", "bhk1"),
                ...extractFlatData("2BHK", "bhk2"),
                ...extractFlatData("3BHK", "bhk3"),
                ...extractFlatData("4BHK", "bhk4"),
            }));

            setAvailabilityStatus(res.availability || "");
            setSelectedAmenities(parsedData.amenities);
            setSelectedLocationAdvantages(parsedData.locationAdvantages);
            setSelectedWaterSupply(parsedData.water_supply);
            setSelectedSecurity(parsedData.security);
        } catch (error) {
            console.error("Error fetching property data:", error);
        }
    };



    useEffect(() => {
        fetchAmenities();
        fetchLocationAdvantages();
        fetchCategory();
        fetchSecurityFeature();
        fetchWaterSupply();
        // fetchDataProperty();
    }, []);

    useEffect(() => {
        fetchData();
    }, [id]);


    const fetchAmenities = async () => {
        try {
            const response = await fetch(`https://100real.xyz/amenities/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setAmenities(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    const fetchLocationAdvantages = async () => {
        try {
            const response = await fetch(`https://100real.xyz/location/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setLocationAdvantages(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching location advantages:", error);
        }
    };

    const fetchWaterSupply = async () => {
        try {
            const response = await fetch(`https://100real.xyz/water-supply/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setWaterSupply(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    const fetchSecurityFeature = async () => {
        try {
            const response = await fetch(`https://100real.xyz/security/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setSecurity(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    const fetchCategory = async () => {
        try {
            const response = await axios.get(`https://100real.xyz/propertycategory/all/${isLoggedIn.user_id}`);
            const activeAmenities = response.data.filter(amenity => amenity.status === 'active');
            setCategory(activeAmenities.reverse());

        } catch (error) {
            console.error('Error fetching amenities:', error);
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoad(false);

        // if (validateFields()) {
        const rkDetails = {
            type: "1RK",
            carpetAreas: data.rkCarpetAreas,
            builtUpAreas: data.rkBuiltUpAreas,
            superBuiltUpAreas: data.rkSuperBuiltUpAreas,
            balconies: data.rkBalconies,
            bathrooms: data.rkBathrooms,
            furnishStatus: data.rkFurnishStatus,
            conditionOfFlat: data.rkConditionOfFlat,
            expectedPrice: data.rkExpectedPrices,
            monthlyMaintenance: data.rkMonthlyMaintenance,
            priceAllInclusive: data.rkPriceAllInclusive,
            priceNegotiable: data.rkPriceNegotiable,
            preferredCashType: data.rkPreferredCashType,
            loanFacility: data.rkLoanFacility,
            documentsAvailable: data.rkDocumentsAvailable,
            floorPlan: data.rkFloorPlan,
        };

        const bhk1Details = {
            type: "1BHK",
            carpetAreas: data.bhk1CarpetAreas,
            builtUpAreas: data.bhk1BuiltUpAreas,
            superBuiltUpAreas: data.bhk1SuperBuiltUpAreas,
            bedrooms: data.bhk1Bedrooms,
            balconies: data.bhk1Balconies,
            bathrooms: data.bhk1Bathrooms,
            furnishStatus: data.bhk1FurnishStatus,
            conditionOfFlat: data.bhk1ConditionOfFlat,
            expectedPrice: data.bhk1ExpectedPrice,
            monthlyMaintenance: data.bhk1MonthlyMaintenance,
            priceAllInclusive: data.bhk1PriceAllInclusive,
            priceNegotiable: data.bhk1PriceNegotiable,
            preferredCashType: data.bhk1PreferredCashType,
            loanFacility: data.bhk1LoanFacility,
            documentsAvailable: data.bhk1DocumentsAvailable,
            floorPlan: data.bhk1FloorPlan,
        };

        const bhk2Details = {
            type: "2BHK",
            carpetAreas: data.bhk2CarpetAreas,
            builtUpAreas: data.bhk2BuiltUpAreas,
            superBuiltUpAreas: data.bhk2SuperBuiltUpAreas,
            bedrooms: data.bhk2Bedrooms,
            balconies: data.bhk2Balconies,
            bathrooms: data.bhk2Bathrooms,
            furnishStatus: data.bhk2FurnishStatus,
            conditionOfFlat: data.bhk2ConditionOfFlat,
            expectedPrice: data.bhk2ExpectedPrice,
            monthlyMaintenance: data.bhk2MonthlyMaintenance,
            priceAllInclusive: data.bhk2PriceAllInclusive,
            priceNegotiable: data.bhk2PriceNegotiable,
            preferredCashType: data.bhk2PreferredCashType,
            loanFacility: data.bhk2LoanFacility,
            documentsAvailable: data.bhk2DocumentsAvailable,
            floorPlan: data.bhk2FloorPlan,
        };

        const bhk3Details = {
            type: "3BHK",
            carpetAreas: data.bhk3CarpetAreas,
            builtUpAreas: data.bhk3BuiltUpAreas,
            superBuiltUpAreas: data.bhk3SuperBuiltUpAreas,
            bedrooms: data.bhk3Bedrooms,
            balconies: data.bhk3Balconies,
            bathrooms: data.bhk3Bathrooms,
            furnishStatus: data.bhk3FurnishStatus,
            conditionOfFlat: data.bhk3ConditionOfFlat,
            expectedPrice: data.bhk3ExpectedPrice,
            monthlyMaintenance: data.bhk3MonthlyMaintenance,
            priceAllInclusive: data.bhk3PriceAllInclusive,
            priceNegotiable: data.bhk3PriceNegotiable,
            preferredCashType: data.bhk3PreferredCashType,
            loanFacility: data.bhk3LoanFacility,
            documentsAvailable: data.bhk3DocumentsAvailable,
            floorPlan: data.bhk3FloorPlan,
        };

        const bhk4Details = {
            type: "4BHK",
            carpetAreas: data.bhk4CarpetAreas,
            builtUpAreas: data.bhk4BuiltUpAreas,
            superBuiltUpAreas: data.bhk4SuperBuiltUpAreas,
            bedrooms: data.bhk4Bedrooms,
            balconies: data.bhk4Balconies,
            bathrooms: data.bhk4Bathrooms,
            furnishStatus: data.bhk4FurnishStatus,
            conditionOfFlat: data.bhk4ConditionOfFlat,
            expectedPrice: data.bhk4ExpectedPrice,
            monthlyMaintenance: data.bhk4MonthlyMaintenance,
            priceAllInclusive: data.bhk4PriceAllInclusive,
            priceNegotiable: data.bhk4PriceNegotiable,
            preferredCashType: data.bhk4PreferredCashType,
            loanFacility: data.bhk4LoanFacility,
            documentsAvailable: data.bhk4DocumentsAvailable,
            floorPlan: data.bhk4FloorPlan,
        };
        const formDataPayload = new FormData();

        const flatTypeData = [
            {
                ...rkDetails,
                floorPlan: data.rkFloorPlan ? data.rkFloorPlan.name : null,
            },
            {
                ...bhk1Details,
                floorPlan: data.bhk1FloorPlan ? data.bhk1FloorPlan.name : null,
            },
            {
                ...bhk2Details,
                floorPlan: data.bhk2FloorPlan ? data.bhk2FloorPlan.name : null,
            },
            {
                ...bhk3Details,
                floorPlan: data.bhk3FloorPlan ? data.bhk3FloorPlan.name : null,
            },
            {
                ...bhk4Details,
                floorPlan: data.bhk4FloorPlan ? data.bhk4FloorPlan.name : null,
            },
        ];

        formDataPayload.append("flatType", JSON.stringify(flatTypeData));
        formDataPayload.append("building_name", data.building_name);
        formDataPayload.append("address", data.address);
        formDataPayload.append("city", data.city);
        formDataPayload.append("user_id", isLoggedIn.user_id);
        formDataPayload.append("amenities", JSON.stringify(selectedAmenities));
        formDataPayload.append("totalFloors", data.totalFloors);
        formDataPayload.append("floorLevel", data.floorLevel);
        formDataPayload.append("availability", availabilityStatus);
        formDataPayload.append("ageOfBuilding", data.ageOfBuilding);
        formDataPayload.append("possesionTill", data.possesionTill);
        formDataPayload.append("under_construction", data.under_construction);
        formDataPayload.append("ownership", data.ownership);
        formDataPayload.append("facing", data.facing);
        formDataPayload.append("brokage", data.brokage);
        formDataPayload.append("parking", data.parking);
        formDataPayload.append("booking_amount", data.booking_amount);
        formDataPayload.append("locationAdvantage", JSON.stringify(selectedLocationAdvantages));
        formDataPayload.append("water_supply", JSON.stringify(selectedWaterSupply));
        formDataPayload.append("security", JSON.stringify(selectedsecurity));
        formDataPayload.append("virtual_tour", data.virtual_tour);
        formDataPayload.append("developer_name", data.developer_name);
        formDataPayload.append("developer_description", data.developer_description);
        formDataPayload.append("property_description", data.property_description);
        // ✅ Handle file uploads (Update floor plans if new ones exist)
        if (data.floorPlan) {
            formDataPayload.append("floorPlan", data.floorPlan);
        }
        if (data.dev_logo) {
            formDataPayload.append("dev_logo", data.dev_logo); // Match the backend field name
        }
        uploadedFiles.forEach((image, index) => {
            formDataPayload.append(`formImages`, image);
        });

        if (data.rkFloorPlan) {
            formDataPayload.append("rkFloorPlan", data.rkFloorPlan);
        }
        if (data.bhk1FloorPlan) {
            formDataPayload.append("bhk1FloorPlan", data.bhk1FloorPlan);
        }
        if (data.bhk2FloorPlan) {
            formDataPayload.append("bhk2FloorPlan", data.bhk2FloorPlan);
        }
        if (data.bhk3FloorPlan) {
            formDataPayload.append("bhk3FloorPlan", data.bhk3FloorPlan);
        }
        if (data.bhk4FloorPlan) {
            formDataPayload.append("bhk4FloorPlan", data.bhk4FloorPlan);
        }

        // ✅ Track deleted images


        try {
            const response = await fetch(`https://100real.xyz/rentresident/update-property/${id}`, {
                method: "PUT",
                body: formDataPayload,
            });
            const result = await response.json();
            if (response.ok) {
                toast.success("Property Updated Successfully!");
                navigate(`/property-2`)
                setLoad(true);
            } else {
                setLoad(true);
                console.error("Error updating property:", result.message);
            }
        } catch (error) {
            setLoad(true);
            console.error("Network error:", error);
        }
        // } else {
        //     setLoad(true);
        //     toast.error("Please fill all required fields correctly.",{
        //         position: "top-center",
        //         autoClose: 2000,
        //     });
        // }
    };



    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <form className="property-form" onSubmit={handleSubmit}>
                    <h2>Property Details Form</h2>
                    <div>
                        <label>Building/Project Name</label>
                        <input type="text" name="building_name" value={data.building_name} onChange={handleInputChange} placeholder="Enter Building/Project Name"/>
                    </div>
                    <div>
                        <label>Address</label>
                        <input type="text" name="address" value={data.address} onChange={handleInputChange} placeholder="Enter Full Address"/>
                    </div>
                    <div>
                        <label>City</label>
                        <input type="text" name="city" value={data.city} onChange={handleInputChange} placeholder="Enter City"/>
                    </div>
                    {/* Amenities Input */}
                    <div className="location">
                        <div>
                            <label>Amenities</label>
                            <div className="button-group">
                                {amenities.map((amenity) => (
                                    <button
                                        type="button"
                                        key={amenity.id}
                                        className={`toggle-button ${selectedAmenities.includes(amenity.name) ? "selected" : ""}`}
                                        onClick={() => toggleAmenity(amenity.name)}
                                    >
                                        {amenity.name}
                                    </button>
                                ))}



                            </div>
                        </div>
                    </div>

                    {/* <div className="form-container">
                    <div className="post-input">
                        <label>Flat Type</label>
                        <div className="checkbox-group">
                            <div className="checkbox-option">
                                <input
                                    type="checkbox"
                                    name="flatType"
                                    value="1RK"
                                    id="flattype-1RK"
                                    checked={data.flatType.includes("1RK")}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor="flattype-1RK">1RK</label>
                            </div>
                            <div className="checkbox-option">
                                <input
                                    type="checkbox"
                                    name="flatType"
                                    value="1BHK"
                                    id="flattype-1BHK"
                                    checked={data.flatType.includes("1BHK")}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor="flattype-1BHK">1BHK</label>
                            </div>
                            <div className="checkbox-option">
                                <input
                                    type="checkbox"
                                    name="flatType"
                                    value="2BHK"
                                    id="flattype-2BHK"
                                    checked={data.flatType.includes("2BHK")}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor="flattype-2BHK">2BHK</label>
                            </div>
                            <div className="checkbox-option">
                                <input
                                    type="checkbox"
                                    name="flatType"
                                    value="3BHK"
                                    id="flattype-3BHK"
                                    checked={data.flatType.includes("3BHK")}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor="flattype-3BHK">3BHK</label>
                            </div>
                            <div className="checkbox-option">
                                <input
                                    type="checkbox"
                                    name="flatType"
                                    value="4BHK"
                                    id="flattype-4BHK"
                                    checked={data.flatType.includes("4BHK")}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor="flattype-4BHK">4BHK</label>
                            </div>
                        </div>
                    </div>

                    
                    {data.flatType.includes("1RK") && render1RKSection()}
                    {data.flatType.includes("1BHK") && render1BHKSection()}
                    {data.flatType.includes("2BHK") && render2BHKSection()}
                    {data.flatType.includes("3BHK") && render3BHKSection()}
                    {data.flatType.includes("4BHK") && render4BHKSection()}
                </div> */}
                    <div className="form-container">
                        <div className="post-input">
                            <label>Flat Type</label>
                            <div className="radio-group">
                                {["1RK", "1BHK", "2BHK", "3BHK", "4BHK"].map((type) => (
                                    <div className="radio-option" key={type}>
                                        <input
                                            type="radio"
                                            name="flatType"
                                            value={type}
                                            id={`flattype-${type}`}
                                            checked={data.flatType.includes(type)}
                                            onChange={(e) =>
                                                setData((prev) => ({ ...prev, flatType: e.target.value }))
                                            }
                                        />
                                        <label htmlFor={`flattype-${type}`}>{type}</label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Render sections based on selected flat types */}
                        {data.flatType.includes("1RK") && render1RKSection()}
                        {data.flatType.includes("1BHK") && render1BHKSection()}
                        {data.flatType.includes("2BHK") && render2BHKSection()}
                        {data.flatType.includes("3BHK") && render3BHKSection()}
                        {data.flatType.includes("4BHK") && render4BHKSection()}
                    </div>

                    <div>
                        <label>Total Number of Floors</label>
                        <input type="number" name="totalFloors" value={data.totalFloors} onChange={handleInputChange} placeholder="Enter Total Number of Floors"/>
                    </div>
                    <div>
                        <label>Floor Number</label>
                        <input type="number" name="floorLevel" value={data.floorLevel} onChange={handleInputChange} placeholder="Enter Floor Number (e.g., 1, 2, etc.)"/>
                    </div>

                    <div className="radio-group">
                        <label>Availability Status</label>
                        <input
                            type="radio"
                            id="availability-ready"
                            name="availability"
                            value="Ready to Move"
                            checked={availabilityStatus === "Ready to Move"}
                            onChange={() => setAvailabilityStatus("Ready to Move")}
                        />
                        <label htmlFor="availability-ready">Ready to Move</label>
                        <input
                            type="radio"
                            id="availability-under"
                            name="availability"
                            value="Under Construction"
                            checked={availabilityStatus === "Under Construction"}
                            onChange={() => setAvailabilityStatus("Under Construction")}
                        />
                        <label htmlFor="availability-under">Under Construction</label>
                    </div>
                    {availabilityStatus === "Ready to Move" ? (
                        <div>
                            <label>Age of Building (years)</label>
                            <input type="text" name="ageOfBuilding" placeholder="Enter Age of Building" value={data.ageOfBuilding} onChange={handleInputChange} />
                        </div>
                    ) : (
                        <div>
                            <label>Possession Till</label>
                            <input type="date" name="possesionTill" placeholder="Select Possession Date" value={data.possesionTill} onChange={handleInputChange} />
                        </div>
                    )}
                    <div className="radio-group">
                        <label>Ownership</label>
                        <input type="radio" id="ownership-freehold" name="ownership" value="freehold" onChange={handleInputChange} />
                        <label htmlFor="ownership-freehold">Freehold</label>
                        <input type="radio" id="ownership-leasehold" name="ownership" value="leasehold" onChange={handleInputChange} />
                        <label htmlFor="ownership-leasehold">Leasehold</label>
                        <input type="radio" id="ownership-SRA-Redevelopment" name="ownership" value="SRA-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="ownership-SRA-Redevelopment">SRA Redevelopment</label>
                        <input type="radio" id="ownership-Society-Redevelopment" name="ownership" value="Society-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="ownership-Society-Redevelopment">Society Redevelopment</label>
                        <input type="radio" id="ownership-MHADA-Redevelopment" name="ownership" value="MHADA-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="ownership-MHADA-Redevelopment">MHADA Redevelopment</label>
                        <input type="radio" id="ownership-BMC-Redevelopment" name="ownership" value="BMC-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="ownership-BMC-Redevelopment">BMC Redevelopment</label>
                    </div>
                    <div className="radio-group">
                        <label>Facing Direction</label>
                        <input type="radio" id="facing-north" name="facing" value="north"
                            checked={data.facing === "north"}
                            onChange={handleInputChange} />
                        <label htmlFor="facing-north">North</label>
                        <input type="radio" id="facing-south" name="facing" value="south" checked={data.facing === "south"} onChange={handleInputChange} />
                        <label htmlFor="facing-south">South</label>
                        <input type="radio" id="facing-east" name="facing" value="east" checked={data.facing === "east"} onChange={handleInputChange} />
                        <label htmlFor="facing-east">East</label>
                        <input type="radio" id="facing-west" name="facing" value="west" checked={data.facing === "west"} onChange={handleInputChange} />
                        <label htmlFor="facing-west">West</label>
                    </div>
                    <div className="radio-group">
                        <label className="margin-top-10px-oms-div">Brokage</label>
                        <input
                            type="radio"
                            id="brokage-yes"
                            name="brokage"
                            // value={data.brokage}
                            checked={data.brokage === "yes"}
                            value="yes"
                            onChange={handleInputChange}
                        />
                        <label htmlFor="brokage-yes">Yes</label>
                        <input
                            type="radio"
                            id="brokage-no"
                            name="brokage"
                            checked={data.brokage === "no"}
                            value="no"
                            onChange={handleInputChange}
                        />
                        <label htmlFor="brokage-no">No</label>
                    </div>
                    <div>
                        <label>Parking</label>
                        <input type="number" name="parking" placeholder="Enter Number of Parking Slots" value={data.parking} onChange={handleInputChange}/>
                    </div>
                    <div>
                        <label>Booking Amount(₹)</label>
                        <input type="number" name="booking_amount" placeholder="Enter Booking Amount" value={data.booking_amount} onChange={handleInputChange}/>
                    </div>
                    <div className="location">
                        <div>
                            <label>Location Advantages</label>
                            <div className="button-group">
                                {locationAdvantages.map((advantage) => (
                                    <button
                                        type="button"
                                        key={advantage.id}
                                        className={`toggle-button ${selectedLocationAdvantages.includes(advantage.name)
                                            ? "selected"
                                            : ""
                                            }`}
                                        onClick={() => toggleLocationAdvantage(advantage.name)}
                                    >
                                        {advantage.name}
                                    </button>
                                ))}
                            </div>
                        </div>

                    </div>
                    <div className="location">
                        <div>
                            <label>Water Supply</label>
                            <div className="button-group">
                                {watersupply.map((advantage) => (
                                    <button
                                        type="button"
                                        key={advantage.id}
                                        className={`toggle-button ${selectedWaterSupply.includes(advantage.name)
                                            ? "selected"
                                            : ""
                                            }`}
                                        onClick={() => toggleWaterSupply(advantage.name)}
                                    >
                                        {advantage.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="location">
                        <div>
                            <label>Security</label>
                            <div className="button-group">
                                {security.map((advantage) => (
                                    <button
                                        type="button"
                                        key={advantage.id}
                                        className={`toggle-button ${selectedsecurity.includes(advantage.name)
                                            ? "selected"
                                            : ""
                                            }`}
                                        onClick={() => toggleSecurity(advantage.name)}
                                    >
                                        {advantage.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div>
                        <label>Virtual Tour (URL)</label>
                        <input type="text" name="virtual_tour" placeholder="Enter Virtual Tour URL" value={data.virtual_tour} onChange={handleInputChange} />
                    </div>
                    {/* <div className="radio-group">
                        <label>Property Category</label>
                        {
                            category.map((ele, idx) => (
                                <React.Fragment key={idx}>
                                    <input
                                        type="radio"
                                        id={`category-${ele.name}`}
                                        name="category"
                                        value={ele.name}
                                        checked={ele.name === ele.name}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor={`category-${ele.name}`}>{ele.name}</label>
                                </React.Fragment>
                            ))
                        }


                    </div> */}
                    <div className='margin-top-10px-oms-div'>
                        <label>Developer Logo</label>
                        <input
                            type="file"
                            name="dev_logo"
                            accept="image/*"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="property-images">
                        {/* <h3>Property Images</h3> */}

                        <div className="image-gallery">

                            <div className="image-container1">
                                <img
                                    src={`https://100real.xyz/Images/Store/${data.dev_logo}`}
                                    // alt={`Property Image ${index + 1}`}
                                    className="property-image"
                                />

                            </div>

                        </div>

                    </div>

                    <div>
                        <label>Developer Name</label>
                        <input
                            type="text"
                            name="developerName"
                            placeholder="Enter Developer Name"
                            value={data.developer_name}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div>
                        <label>Developer Description</label>
                        <input
                            type='text'
                            name="developerDescription"
                            placeholder="Enter Developer Description"
                            value={data.developer_description}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div>
                        <label>Property Description</label>
                        <input
                            type='text'
                            name="propertyDescription"
                            placeholder="Enter Property Description"
                            value={data.property_description}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="post-property-image">
                        <p className="post-property-image-head">
                            Upload your image
                        </p>
                        <p className="post-property-limits">
                            You can upload up to 20 images, with a total size limit of 20MB, in JPG or JPEG format.
                        </p>
                        <div
                            className={`post-property-image-container ${dragging ? 'dragging' : ''}`}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                        >
                            <i className="fa-solid fa-arrow-up-from-bracket"></i>
                            <p>Drag and drop your images or</p>
                            <button className="browse-files" onClick={handleBrowseClick}>
                                Browse images
                            </button>
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                multiple
                                accept=".jpg, .jpeg, .webp, .png"
                                onChange={handleFileChange}
                            />
                        </div>
                        <div className="property-images">
                            <h3>Property Images</h3>
                            {data.formImages && data.formImages.length > 0 ? (
                                <div className="image-gallery">
                                    {data.formImages.map((img, index) => (
                                        <div key={index} className="image-container">
                                            <img
                                                src={`https://100real.xyz/Images/Store/${img}`}
                                                alt={`Property Image ${index + 1}`}
                                                className="property-image"
                                            />
                                            <button type='button' className="delete-image-btn" onClick={() => handleDeleteImage(index)}>
                                                <i class="fa-solid fa-xmark"></i>
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p>No images available</p>
                            )}
                        </div>



                        <div className="upload-file-container">
                            {uploadedFiles.length > 0 ? (
                                <>
                                    <p className="upload-file-head">Uploaded Files:</p>
                                    <ul className="upload-file-list">
                                        {uploadedFiles.map((file, index) => (
                                            <li key={index} className="upload-file-item">
                                                <span>{file.name} ({formatFileSize(file.size)})</span>
                                                <button
                                                    className="delete-file-btn"
                                                    onClick={() => handleDeleteFile(index)}
                                                >
                                                    <i className="fa-solid fa-xmark"></i>
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            ) : (
                                <p className="no-files-message">No files uploaded yet.</p>
                            )}
                        </div>
                    </div>
                    {
                        load ? <button type="submit" className='post-property-submit'>Submit</button> :
                            <button type="button" className='post-property-submit' disabled>Loading...</button>
                    }

                </form>
            </div>

            <ToastContainer />
        </>
    );
};

export default ResidentRentEdit;

